import { ActionTree, Commit, GetterTree, MutationTree } from 'vuex'
import stationApi from '../../api/station'

export interface RootState {
    version: string;
}

export class unit {
    value: number | undefined;
    text: string | undefined;
}
const state = Array<unit>();
const getters: GetterTree<Array<unit>, RootState> = {
    unit(state: Array<unit>) {
        return state
    }
};
export const mutations: MutationTree<Array<unit>> = {
    LOAD_UNIT(state: Array<unit>, units: Array<unit>) {
        state.length=0;
        units.forEach(element => {
            state.push(element)
        });
    },
    CLEAR_UNIT(state: Array<unit>) {
        state.length = 0
    }
};
const actions: ActionTree<Array<unit>, RootState> = {
    async getUnits({ state, commit }: { commit: Commit, state: Array<unit> }): Promise<Array<unit>> {
        if (state && state.length > 0) return state;
        try {
            const response = await stationApi.getUnits()
            if (response && response.data && response.data.resultType === 200) {
                const data = response.data.payload.map((e: { name: string; id: number; }) =>
                    ({ text: e.name, value: e.id }))
                commit('LOAD_UNIT', data)
                return state;
            }
            else {
                commit('CLEAR_UNIT')
                return state;
            }
        }
        catch (error) {
            commit('CLEAR_UNIT')
            return state;
        }
    }
}
export default {
    state,
    getters,
    mutations,
    actions
}